import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { formatError } from '@/services/api';

import i18n from '@/settings/i18n';
import { articlesApi } from '@/services/api';

export const fetchAll = createAsyncThunk(
  'article/fetchAll',
  async (_, { rejectWithValue }) => {
    const params = { params: { lang: i18n.languages[0] } };
    try {
      const response = await articlesApi.getList(params);
      return response;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response !== undefined) {
        return rejectWithValue({ error: formatError(error.response) });
      }
      throw error;
    }
  },
);
